import React from 'react';
import { LightbulbIcon, CheckCircleIcon } from 'lucide-react';
export const Solution = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-329">
      <div className="bg-blue-50 p-5 rounded-lg mb-8 border-l-4 border-blue-500" data-id="element-330">
        <h2 className="text-xl font-bold text-blue-800 flex items-center mb-4" data-id="element-331">
          <LightbulbIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-332" />
          Hoe ga je dan om met probleemgedrag? Want je houdt van je hond en wil
          dat hij/zij blij is en zich goed gedraagt...
        </h2>
        <p className="mb-4 leading-relaxed" data-id="element-333">
          Volgens Amee werken hondenscholen nog vaak met achterhaalde ideeën
          over dominantie en conditionering, zegt ze tijdens haar webinar. Maar
          tegenwoordig weten we dat:
        </p>
        <ul className="mb-4 list-disc pl-5 space-y-2" data-id="element-334">
          <li data-id="element-335">Probleemgedrag een uiting is van een onderliggend probleem</li>
          <li data-id="element-336">
            De meeste honden stress ervaren zonder dat het baasje dit doorheeft
          </li>
          <li data-id="element-337">
            Als baasjes communicatie signalen van hun hond leren herkennen, ze
            problemen kunnen voorkomen
          </li>
          <li data-id="element-338">
            Wanneer een baasje leert om zijn lichaamstaal te matchen met zijn
            commando's, dat honden hen dan veel beter begrijpen en ineens wel
            luisteren.
          </li>
        </ul>
        <p className="text-lg font-semibold text-blue-800 mb-4" data-id="element-339">
          Door te leren communiceren kunnen baasjes leren om te gaan met hun
          hond zonder te straffen of corrigeren. Problemen worden hierdoor
          minder en de hond veel gelukkiger.
        </p>
        <p className="leading-relaxed mb-4" data-id="element-340">
          In het verleden heeft Amee deze presentatie al voor duizenden
          hondenbaasjes gegeven. Deze week geeft ze hem nogmaals voor elk baasje
          die de agressiviteit van zijn of haar hond liefdevol wil oplossen.
        </p>
        <a href="https://stresslessdogs.nl/mcc-meta-adv1" className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 text-center" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-341">
          BEKIJK BESCHIKBAARHEID WEBINAR
        </a>
      </div>
      <div className="w-full mb-6" data-id="element-342">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iETwyZQdRtoqRfKLXsTijB/Scherm_afbeelding_2025-09-01_om_23.36.13.png" alt="Border Collie met gespannen houding in woonkamer" className="w-full h-auto rounded-lg shadow-md" data-id="element-343" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-344">
          "Straffen maakt honden gestrest. Een gestressde hond is sneller
          agressief."
        </p>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-345">
        Gedragsdeskundige Amee: Straffen zorgt voor stress, stress zorgt voor
        problemen
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-346">
        Amee, hondengedragsexpert bij Stressless Dogs, legt in{' '}
        <a href="https://stresslessdogs.nl/mcc-meta-adv1" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-347">
          haar online presentatie
        </a>{' '}
        uit dat stress de oorzaak is van de meeste problemen bij honden. Een
        hond met stress wordt prikkelbaarder en daarom soms ook agressief.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-348">Wat gebeurt er:</p>
      <div className="mb-6 pl-5 space-y-2" data-id="element-349">
        <p data-id="element-350">
          <span className="font-medium" data-id="element-351">1.</span> Je straft je hond
        </p>
        <p data-id="element-352">
          <span className="font-medium" data-id="element-353">2.</span> Je hond wordt gestresst
        </p>
        <p data-id="element-354">
          <span className="font-medium" data-id="element-355">3.</span> Je hond is hierdoor
          prikkelbaarder
        </p>
        <p data-id="element-356">
          <span className="font-medium" data-id="element-357">4.</span> Je hond reageert sneller
          agressief op zijn omgeving
        </p>
        <p data-id="element-358">
          <span className="font-medium" data-id="element-359">5.</span> Jij straft je hond nog meer
        </p>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-360">
        Bovendien begrijpt een hond niet waarom hij gestraft wordt en weet hij
        niet wat hij dan wel moet doen. Baasjes weten slecht hoe ze ervoor
        kunnen zorgen dat hun hond wel gewenst gedrag laat zien. Daarom geef ik
        vandaag en morgen hier weer gratis online presentaties over (
        <a href="https://stresslessdogs.nl/mcc-meta-adv1" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-361">
          hier meer info
        </a>
        )
      </p>
    </section>;
};